export type DuctRunEmphasisType = {
  emphasized: boolean;
  dimmed: boolean;
  strokeWidthScale: number;
  opacityScale: number;
};

export function resolveDuctRunEmphasis(
  hoveredZoneUniqueId: string | null,
  zoneUniqueId: string | undefined
): DuctRunEmphasisType {
  if (!hoveredZoneUniqueId) {
    return {
      emphasized: false,
      dimmed: false,
      strokeWidthScale: 1,
      opacityScale: 1
    };
  }
  if (hoveredZoneUniqueId === zoneUniqueId) {
    return {
      emphasized: true,
      dimmed: false,
      strokeWidthScale: 1.8,
      opacityScale: 1.4
    };
  }
  return {
    emphasized: false,
    dimmed: true,
    strokeWidthScale: 1,
    opacityScale: 0.3
  };
}

export function scaledRunOpacity(
  baseOpacity: number,
  emphasis: DuctRunEmphasisType
): number {
  return Math.min(1, baseOpacity * emphasis.opacityScale);
}
